import { words } from "./dictionary.js";
function browserRandomInt(max) {
  if (typeof window === "undefined") {
    throw new Error("browserRandomInt is not available in Node environments");
  }
  const cryptoRand = () => {
    const array = new Int8Array(4);
    window.crypto.getRandomValues(array);
    const dataView = new DataView(array.buffer);
    const uint = dataView.getUint32(0);
    return uint / (4294967295 + 1);
  };
  return Math.floor(cryptoRand() * (max + 1));
}
const randomInt = typeof window === "undefined" ? (await import("node:crypto")).randomInt : browserRandomInt;
function randomSlug(opts = {}) {
  if (opts.words && (opts.words < 1 || opts.words > 4)) {
    throw new TypeError("Word count must be between 1-4");
  }
  opts.separator = opts.separator || "-";
  opts.words = opts.words || 2;
  const salt = opts.salt ? [createSalt(opts.salt)] : [];
  return getWords(opts.words).concat(salt).join(opts.separator);
}
const mergedWords = [...words.adjectives, ...words.nouns, ...words.verbs];
function getWords(count) {
  if (count === 0) return [];
  if (count === 1) return [randomFromArray(mergedWords)];
  if (count === 2)
    return [randomFromArray(words.adjectives), randomFromArray(words.nouns)];
  if (count === 3)
    return [
      randomFromArray(words.adjectives),
      randomFromArray(words.nouns),
      randomFromArray(words.verbs)
    ];
  return [
    randomFromArray(words.adjectives),
    randomFromArray(words.adjectives),
    randomFromArray(words.nouns),
    randomFromArray(words.verbs)
  ];
}
function randomFromArray(arr) {
  return arr[randomInt(arr.length - 1)];
}
function createSalt(length) {
  const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
  let value = "";
  for (let i = 0; i < length; i++) {
    value += chars[randomInt(chars.length - 1)];
  }
  return value;
}
function getRandomWord(type) {
  if (type === "adjective") return randomFromArray(words.adjectives);
  if (type === "noun") return randomFromArray(words.nouns);
  if (type === "verb") return randomFromArray(words.verbs);
  return randomFromArray(words.nouns);
}
export {
  createSalt,
  getRandomWord,
  randomFromArray,
  randomSlug
};
//# sourceMappingURL=random-slug.js.map
